import { render, staticRenderFns } from "./MilkReport.vue?vue&type=template&id=288ae576&"
import script from "./MilkReport.vue?vue&type=script&lang=js&"
export * from "./MilkReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports